import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolDrakeHextech = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 7.25919L8.62137 2.07314L8.49402 0L1 7.25122L6.32735 12.3543L6.05942 15L14 7.25919ZM7.58435 2.7525L9.0729 4.18775L7.58435 5.62301L6.0958 4.18775L7.58435 2.7525ZM3.94567 7.92898L6.33893 5.61982L7.5827 6.76802L8.75865 5.61982L11.0742 7.92898L7.50827 11.3672L3.94567 7.92898Z",
		fill: "currentColor"
	})
});
export default SvgLolDrakeHextech;
